<i18n
  src="@/locales/views/service_provider/services/container_op/edit_container.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/container_scheduled_service.yml" lang="yaml"></i18n>
<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    name="sp_services_container_op_show_schedule_path"
    :params="{
      service_provider_id: service_provider_id,
      agro_exporter_id: agro_exporter_id,
      container_scheduled_service_id: container_scheduled_service_id,
    }"
  />
  <bread-crumbs :labels="[module_name]"></bread-crumbs>
  <template v-if="container_scheduled_service">
    <container-scheduled-service-info
      :container_scheduled_service="container_scheduled_service"
    />
    <alert-danger :errors_data="std_err" />
    <div class="mt-8">
      <div class="panel">
        <div class="panel-header">
          <h3 class="panel-header-title">
            {{ $t("labels.title") }}
          </h3>
        </div>
        <div class="panel-body" v-if="container_scheduled_service">
          <div class="space-y-8 divide-y divide-gray-200">
            <container-input
              v-if="agro_exporter"
              v-model="container_scheduled_service.container"
              :containers="containers"
              :agro_exporter_processes="agro_exporter.agro_exporter_processes"
            ></container-input>
          </div>
        </div>
        <div class="panel-footer" v-if="container_scheduled_service">
          <div class="panel-footer-actions">
            <div class="panel-footer-actions">
              <white-button
                @click.prevent="goToShowSchedule()"
                :label="$t('labels.cancel_button')"
              />
              <span class="space-actions"></span>
              <success-button
                v-if="!charging_submit"
                @click.prevent="submit()"
                :label="$t('labels.save_button')"
              />
              <success-button-processing
                v-else
                :label="$t('labels.save_button')"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  <loading-message v-else />
  <div />
</template>

<script>
import Requester from "@/views/service_provider/requesters/services/container_op/edit_container.js";
import ContainerInput from "@/components/views/service_provider/services/container_op/ContainerInput.vue";
import BreadCrumbs from "@/components/views/layout/BreadCrumbs.vue";
import ContainerScheduledServiceInfo from "@/components/views/service_provider/services/container_op/ContainerScheduledServiceInfo.vue";

export default {
  components: {
    BreadCrumbs,
    ContainerInput,
    ContainerScheduledServiceInfo,
  },
  props: [
    "service_provider_id",
    "agro_exporter_id",
    "container_scheduled_service_id",
  ],
  data() {
    return {
      agro_exporter: null,
      container_scheduled_service: null,
      containers: [],
      charging_submit: false,
    };
  },
  computed: {
    can_send: function () {
      return !this.charging_submit;
    },
    params: function () {
      return {
        container_scheduled_service_id: this.container_scheduled_service_id,
        container_id: this.container_scheduled_service?.container?.id,
        container_code:
          this.container_scheduled_service?.container?.container_code,
        agro_exporter_process_id:
          this.container_scheduled_service?.container?.agro_exporter_process_id,
      };
    },
    save_link_class: function () {
      let basic_class = "btn-main";
      if (this.can_send) return basic_class;
      return `${basic_class}  opacity-50 cursor-not-allowed`;
    },
  },
  methods: {
    fetchAgroExporter: async function () {
      let response = await Requester.fetchAgroExporter({
        container_scheduled_service_id: this.container_scheduled_service_id,
      });
      this.agro_exporter = response.data;
    },
    fetchContainers: async function () {
      let response = await Requester.fetchContainers({
        container_scheduled_service_id: this.container_scheduled_service_id,
      });
      this.containers = response.data;
    },
    fetchSchedule: async function () {
      let response = await Requester.fetchSchedule({
        container_scheduled_service_id: this.container_scheduled_service_id,
      });
      let container_scheduled_service = response.data;
      this.container_scheduled_service = container_scheduled_service;
    },
    goToShowSchedule: function () {
      this.$router.push({
        name: "sp_services_container_op_show_schedule_path",
        params: {
          agro_exporter_id: this.agro_exporter_id,
          container_scheduled_service_id: this.container_scheduled_service_id,
          service_provider_id: this.service_provider_id,
        },
      });
    },
    submit: async function () {
      if (!this.can_send) return;
      this.charging_submit = true;
      try {
        let response = await Requester.update(this.params);
        this.registerSuccessNotification({
          title: response.data.success_message,
        });
        this.goToShowSchedule();
      } catch (error) {
        if (error?.response?.status == 422) {
          this.loadStandardErrorMessages({
            title: error.response.data.error_title,
            messages: error.response.data.error_messages,
            fields: error.response.data.error_fields,
          });
        }
      }
      this.charging_submit = false;
    },
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          service_provider_id: this.service_provider_id,
        },
      }).then(() => {
        this.fetchAgroExporter();
        this.fetchContainers().then(() => this.fetchSchedule());
      })
    );
  },
};
</script>
